import { select, takeLatest } from 'redux-saga/effects'

import {
  SET_OUTPUT_FIELD,
  UPDATE_OUTPUT_QUERY,
  SET_CAN_ID,
  RESET_OUTPUT_NODE,
} from 'actions/feature/outputs'
import { SET_FEATURE_FIELD } from 'actions/feature/featureMetadata'

import {
  UPDATE_FEATURE_STATUS,
  SAVE_FEATURE,
  UPDATE_FEATURE,
} from 'actions/feature/features'

// for queries
import {
  UPDATE_SELECTED_INPUT,
  SWITCH_INPUT_TYPE,
} from 'actions/feature/inputs'
import { SET_QUERY_FIELD, RESET_QUERY } from 'actions/feature/queries'
import {
  SET_CONDITION_FIELD,
  RESET_CONDITION,
} from 'actions/feature/conditions'

import { RESET_LOGIC_NODE } from 'actions/feature/logicNodes'
import { ADD_HARNESS } from 'actions/feature/harnesses'

import {
  getCurrentFeature,
  getValidationDescriptions,
} from 'selectors/feature/features'
import { harnessPinIdSetSelector } from 'selectors/feature/harnesses'
import { getOrphanQueryUris } from 'selectors/feature/functionGraphs'
import { getSignalsWithTranslation } from 'selectors/feature/inputs'
import { getFeaturesRouteMatch } from 'selectors/router'
import {
  getFeatureModuleName,
  getFeatureType,
} from 'selectors/feature/featureMetadata'
import { denormalizeFeature } from 'schemas/feature'

import strings from 'utils/strings'

import {
  featureSchema,
  featureSaveSchema,
} from 'schemas/validation/feature/feature'

import { startErrorWatching, validate } from '../validation'

/**
 *
 * helpers
 *
 */

const descriptionEvent = (actionType) => (action) =>
  action.type === actionType && action.paramName === 'description'

/**
 *
 * validators
 *
 */

function* validateFeatureSendToTest(schema) {
  const feature = yield select(getCurrentFeature)
  const descriptions = yield select(getValidationDescriptions)
  const orphanUris = yield select(getOrphanQueryUris)
  const signalsWithTranslations = yield select(getSignalsWithTranslation)
  const pinSet = yield select(harnessPinIdSetSelector)
  const featureModuleName = yield select(getFeatureModuleName)
  const featureType = yield select(getFeatureType)
  const {
    params: { featureId: currentFeatureId },
  } = yield select(getFeaturesRouteMatch)

  const denormalized = denormalizeFeature(currentFeatureId, feature)

  yield validate(schema, denormalized, null, {
    descriptions,
    orphanUris,
    signalsWithTranslations,
    pinSet,
    featureModuleName,
    featureType,
  })
}

function* validateFeatureSave(schema) {
  const feature = yield select(getCurrentFeature)
  const descriptions = yield select(getValidationDescriptions)
  const {
    params: { featureId: currentFeatureId },
  } = yield select(getFeaturesRouteMatch)

  const denormalized = denormalizeFeature(currentFeatureId, feature)

  yield validate(schema, denormalized, null, { descriptions })
}

/**
 *
 * watchers
 *
 */

function* watchSendToTestValidationTriggers() {
  yield takeLatest(
    [
      SET_FEATURE_FIELD,
      SET_QUERY_FIELD,
      SET_CONDITION_FIELD,
      UPDATE_SELECTED_INPUT,
      SWITCH_INPUT_TYPE,
      SET_CAN_ID,
      SET_OUTPUT_FIELD,
      UPDATE_OUTPUT_QUERY,
      RESET_OUTPUT_NODE,
      RESET_LOGIC_NODE,
      RESET_QUERY,
      RESET_CONDITION,
      ADD_HARNESS,
    ],
    validateFeatureSendToTest,
    featureSchema
  )
}

function* watchSaveValidationTriggers() {
  yield takeLatest(
    [
      descriptionEvent(SET_FEATURE_FIELD),
      descriptionEvent(SET_QUERY_FIELD),
      descriptionEvent(SET_OUTPUT_FIELD),
    ],
    validateFeatureSave,
    featureSaveSchema
  )
}

// validator
export function* watchFeatureTestValidation() {
  yield startErrorWatching({
    actionTypes: {
      activate: UPDATE_FEATURE_STATUS,
      abort: SAVE_FEATURE,
      cancel: UPDATE_FEATURE,
    },
    message: strings.feature_cannot_send_to_test_banner,
    handlers: [watchSendToTestValidationTriggers],
  })
}

export function* watchFeatureSaveValidation() {
  yield startErrorWatching({
    actionTypes: {
      activate: SAVE_FEATURE,
      abort: UPDATE_FEATURE_STATUS,
      cancel: UPDATE_FEATURE,
    },
    message: strings.feature_cannot_save_banner,
    handlers: [watchSaveValidationTriggers],
  })
}
